export default __webpack_public_path__ + "static/media/visa.bdbb86c9.png";